import React from 'react';
import { printTime } from '@guryou/utils';

const checkEventSize = event => {
  const milliseconds = +new Date(event.endTime) - +new Date(event.startTime);
  const minutes = milliseconds / 60000;

  if (minutes <= 50) {
    return false;
  }
  return true;
};

const EventField = ({ event }) => {
  const size = checkEventSize(event);
  const displayName = event.name || event.serviceName || '';
  const isWaitingList = event.waitingListPosition != null && event.waitingListPosition > 0;
  const eventColor = event.color || '#E5E7EB';

  const getTextColor = bgColor => {
    if (bgColor === '#E5E7EB' || bgColor === '#e5e7eb') {
      return '#374151';
    }
    return '#FFFFFF';
  };

  const textColor = getTextColor(eventColor);

  const eventContainerStyle = {
    backgroundColor: eventColor,
    margin: 0,
    padding: '4px 6px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    borderRadius: '4px',
    border: 'none',
    boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
    fontSize: '12px',
    lineHeight: '1.3',
    overflow: 'hidden',
  };

  const content = (
    <div
      style={eventContainerStyle}
      data-type={event.type}
      data-waiting-list={isWaitingList}
      data-bought={event.isSessionBought || event.subscriptionId != null}
    >
      <div
        style={{
          fontWeight: 500,
          marginBottom: size ? '4px' : '2px',
          color: textColor,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: size ? 'normal' : 'nowrap',
          width: '100%',
        }}
      >
        {displayName}
        {isWaitingList && <span style={{ fontSize: '10px', fontStyle: 'italic', marginLeft: '4px', opacity: 0.9 }}>(Waiting List)</span>}
      </div>
      {size && (
        <div style={{ fontSize: '10px', color: textColor, opacity: 0.9, lineHeight: '1.4' }}>
          <div>
            {printTime(event.startTime)} - {printTime(event.endTime)}
          </div>
          {event?.resources?.[0]?.name && <div style={{ marginTop: '2px' }}>{event.resources[0].name}</div>}
          {event.capacity !== undefined && event.totalCapacity !== undefined && (
            <div style={{ marginTop: '2px' }}>
              {event.capacity}/{event.totalCapacity}
            </div>
          )}
        </div>
      )}
    </div>
  );

  return content;
};

export default EventField;
